import Card from './component.jsx'

export default Card
